/**
 * 在线咨询聊天相关 HTTP 接口。
 * 直接对接 kefu 后端 (地址见 config.js 的 KF_BACKEND)。
 *
 * 后端 CORS 已开放 (*),无需处理跨域头。
 *
 * ⚠️ 上线部署前请修改 ./config.js 里的 KF_BACKEND 为线上后端地址。
 */
import { KF_HTTP_BASE } from './config'

/** 获取聊天初始化数据 (欢迎语 + 快捷按钮) */
export function getChatInit() {
    return fetch(`${KF_HTTP_BASE}/api/chat/init`, { method: 'GET' })
        .then((res) => res.json())
        .then((body) => {
            if (body && body.code === 200) return body.data
            throw new Error(body && body.message ? body.message : '获取聊天初始化数据失败')
        })
}

/** 加载历史消息 */
export function loadHistory(sessionId) {
    return fetch(`${KF_HTTP_BASE}/api/chat/history?sessionId=${encodeURIComponent(sessionId)}`, {
        method: 'GET'
    })
        .then((res) => res.json())
        .then((body) => {
            if (body && body.code === 200) return body.data || []
            throw new Error(body && body.message ? body.message : '加载历史消息失败')
        })
}

/** 生成并持久化会话 ID (格式 sid_{时间戳}_{随机串}) */
export function generateSessionId() {
    const KEY = 'chat_session_id'
    let sid = ''
    try {
        sid = localStorage.getItem(KEY) || ''
    } catch (e) {
        // 部分浏览器隐私模式下 localStorage 可能抛异常,降级为内存会话
    }
    if (!sid) {
        sid = 'sid_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
        try {
            localStorage.setItem(KEY, sid)
        } catch (e) {
            // 忽略写入失败
        }
    }
    return sid
}
